import { getLang } from "../../global/i18n/translations.js";

const INTERCOM_CLICK_SELECTORS = "[data-framer-name='contact-enterprise-card']";

const MESSAGES = {
  en: "I'm interested in the Enterprise plan",
  fr: "Le plan Enterprise m'intéresse",
  es: "El plan Enterprise me interesa",
  it: "Il piano Enterprise mi interessa",
  de: "Der Enterprise-Plan interessiert mich",
  nl: "Het Enterprise-plan interesseert me",
  pl: "Plan Enterprise mnie interesuje",
  pt: "O plano Enterprise me interessa"
};

export const openIntercomOnClick = () => {
  document.addEventListener("click", (e) => {
    const el = e.target as HTMLElement;
    const target = el.closest(INTERCOM_CLICK_SELECTORS);
    if (!target) return;
    Intercom("showNewMessage", MESSAGES[getLang()]);
  });
};
